var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "PageHeader",
        {
          staticStyle: { "padding-top": "1rem" },
          attrs: { pageTitle: "Panorama" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "0.5rem" } },
            [
              _c("GenericSearchInput", {
                model: {
                  value: _vm.search.textSearch,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "textSearch", $$v)
                  },
                  expression: "search.textSearch"
                }
              }),
              _vm._v(" "),
              _c("SelectPanoramaInstallationStatus", {
                model: {
                  value: _vm.search.installationStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "installationStatus", $$v)
                  },
                  expression: "search.installationStatus"
                }
              }),
              _vm._v(" "),
              _vm.panoramaList.length
                ? _c("SelectPromoter", {
                    attrs: { traderList: _vm.traderList },
                    model: {
                      value: _vm.search.trader,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "trader", $$v)
                      },
                      expression: "search.trader"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("SelectBillingStatus", {
                model: {
                  value: _vm.search.billingStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "billingStatus", $$v)
                  },
                  expression: "search.billingStatus"
                }
              }),
              _vm._v(" "),
              _c("SelectYear", {
                model: {
                  value: _vm.search.year,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "year", $$v)
                  },
                  expression: "search.year"
                }
              }),
              _vm._v(" "),
              _c("SelectAccountManager", {
                model: {
                  value: _vm.search.accountManagerId,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "accountManagerId", $$v)
                  },
                  expression: "search.accountManagerId"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 15,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      this.panoramaStatusSummaryList && !_vm.isLoading
        ? _c(
            "section",
            { staticStyle: { "margin-botton": "2rem" } },
            [
              _c("PanoramaSummaryTable", {
                attrs: {
                  panoramaStatusSummaryList: _vm.panoramaStatusSummaryList
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.panoramaList.length
        ? _c(
            "section",
            {
              staticClass: "d-flex justify-content-between flex-column",
              staticStyle: { "margin-top": "2rem", height: "60%" }
            },
            [
              _c(
                "Table",
                { staticClass: "panorama-table" },
                [
                  _c(
                    "TableHeader",
                    [
                      _c(
                        "TableRow",
                        _vm._l(_vm.panoramaColumns, function(
                          panoramaCol,
                          index
                        ) {
                          return _c(
                            "TableHead",
                            { key: `${panoramaCol.name}_${index}` },
                            [
                              _c("ColumnHeader", {
                                attrs: {
                                  sort: panoramaCol.sort,
                                  somatory: panoramaCol.somatory,
                                  columnName: panoramaCol.name,
                                  columnKey: panoramaCol.key,
                                  columnType: panoramaCol.columnType,
                                  currentColumnFiltered:
                                    _vm.currentColumnFiltered,
                                  sortDirection: _vm.sortDirection,
                                  dataList: _vm.panoramaList
                                },
                                on: {
                                  sortListByKey: function($event) {
                                    return _vm.sortListByKey(panoramaCol.key)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.panoramaList, function(panorama, index) {
                      return _c(
                        "TableRow",
                        { key: `${panorama.name}_${index}` },
                        [
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(panorama.installationNumber) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: panorama.name }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              style: _vm.setInstallationStatusColor(
                                panorama.installationStatus
                              )
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.translateInstallationStatus(
                                      panorama.installationStatus
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: panorama.totalValue }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", { staticClass: "money-cell" }, [
                            panorama.qtyOverdueInvoice
                              ? _c(
                                  "div",
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(panorama.qtyOverdueInvoice) +
                                        " |\n              "
                                    ),
                                    _c("RenderMoneyColumnValue", {
                                      attrs: {
                                        value: panorama.totalOverdueInvoiceValue
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              staticStyle: {
                                "border-left": "2px solid gray !important"
                              }
                            },
                            [
                              panorama.janInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.janInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.janInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.febInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.febInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.febInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.marInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.marInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.marInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.aprInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.aprInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.aprInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.mayInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.mayInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.mayInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.junInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.junInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.junInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.julInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.julInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.julInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.augInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.augInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.augInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.sepInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.sepInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.sepInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.octInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.octInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.octInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              panorama.novInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.novInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.novInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              staticStyle: { "border-right": "2px solid gray" }
                            },
                            [
                              panorama.decInvoiceData
                                ? _c("RenderPanoramaInvoiceLine", {
                                    attrs: {
                                      "invoice-value":
                                        panorama.decInvoiceData.boletoVeins,
                                      "panorama-invoice-status":
                                        panorama.decInvoiceData.status
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              style: {
                                color: _vm.defineQtyDaysInStatusColor(
                                  panorama.qtyDaysInStatus
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(panorama.qtyDaysInStatus) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "money-cell" },
                            [
                              _c("RenderDateColumnValue", {
                                attrs: {
                                  formatType: "DD",
                                  value: panorama.dueDate
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: {
                                  "social-number": panorama.socialNumber
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              panorama.traderName
                                ? _c("RenderNameColumnValue", {
                                    attrs: { name: panorama.traderName }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              panorama.accountManagerName
                                ? _c("RenderNameColumnValue", {
                                    attrs: { name: panorama.accountManagerName }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : !_vm.isLoading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }